import React from 'react';
import videojs from 'video.js';
import Player from './Player';
import './css/player.css';

/**
 * @author imshawan <github@imshawan.dev>
 * @function VideoPlayer
 * @description This is a wrapper functional component that renders a video player using the video.js library.
 * It takes in the following props:
 * - height (string): The height of the video player
 * - width (string): The width of the video player
 * - sources (array): An array of source objects for the video player
 * 
 * @param {*} props 
 * @param {string} props.height - The height of the video player
 * @param {string} props.width - The width of the video player
 * @param {array} props.sources - An array of source objects for the video player 
 * @param {function} props.onPlay - A callback function to be called when the video starts playing
 * @param {function} props.onTimeUpdate - A callback function to be called when the video time updates
 * @returns {React.FC}
 */
export default function VideoPlayer({
    // height = "500px", width = "700px",
    sources = [{ src: "" }], onPlay, onTimeUpdate, }) {
    const playerRef = React.useRef(null);

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        // width: parseInt(width),  //  Ensures fixed width
        // height: parseInt(height), //  Ensures fixed height
        borderRadius: 4,
        aspectRatio: "16:9",
        sources: sources && Array.isArray(sources) ? sources : [],
        controlBar: {
            children: [
                'playToggle',              // Play button
                'currentTimeDisplay',      // Elapsed time
                'progressControl',         // Progress bar
                'remainingTimeDisplay',    // Remaining time
                'volumePanel',             // Volume control
                'playbackRateMenuButton',  // Settings/Playback speed
                'SettingsButton',
                'fullscreenToggle'         // Fullscreen button
            ],
        },
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        // Function to show elements
        function showElements() {
            const customElements = document.querySelectorAll('.custom-control');
            customElements.forEach(e => e.classList.remove('inactive'));
        }

        // Function to hide elements
        function hideElements() {
            const customElements = document.querySelectorAll('.custom-control');
            customElements.forEach(e => e.classList.add('inactive'));
        }


        player.on('waiting', () => {
            videojs.log('player is waiting');
        });

        player.on('dispose', () => {
            videojs.log('player will dispose');
        });

        player.on('play', onPlay);
        player.on('timeupdate', function () {
            if (onTimeUpdate && typeof onTimeUpdate === 'function') {
                onTimeUpdate(player);
            }
        });
        player.on('useractive', showElements);
        player.on('userinactive', hideElements);

        player.addChild('BackwardButtonOverlay', {});
        player.addChild('PlayPauseOverlay', {});
        player.addChild('ForwardButtonOverlay', {});
    };

    return (
        <div className="video-container" >
            {/* <div className="custom-video-player" > */}
            <Player
                options={videoJsOptions}
                onReady={handlePlayerReady}
            // height={height}
            // width={width}
            />
        </div>
    )

}